import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const staffTexts: Record<string, IOnboardingStepText> = {
  'staff.intro': {
    title: 'Персонал',
    text: 'Сотрудники организации: должности, подразделения, роли и доступ к порталу. Покажем, как всё устроено.',
  },
  'staff.add': {
    title: 'Новый сотрудник',
    text: 'Заведите сотрудника: ФИО, контакты, подразделение и должность.',
  },
  'staff.statistics': {
    title: 'Статистика',
    text: 'Графики по персоналу: численность, распределение по подразделениям, статусы учётных записей.',
  },
  'staff.structure': {
    title: 'Структура',
    text: 'Схема подразделений организации с руководителями и сотрудниками.',
  },
  'staff.structure.tree': {
    title: 'Структура компании',
    text: 'Дерево подразделений. Вложенные отделы раскрываются кнопкой «Подразделений» внизу карточки — как у АХС. Клик по подразделению показывает его сотрудников, схему можно масштабировать и двигать мышью.',
  },
  'staff.settings': {
    title: 'Настройки',
    text: 'Справочники модуля: структура подразделений и должности. Доступны администраторам.',
  },
  'staff.settings.tabs': {
    title: 'Структура МО и должности',
    text: 'На вкладке «Структура МО» — подразделения и их сотрудники, на вкладке «Должности» — справочник должностей и кто на них назначен.',
  },
  'staff.settings.content': {
    title: 'Справочник и сотрудники',
    text: 'Слева выберите подразделение или должность — справа появятся сотрудники. Их можно добавить, переместить в другое подразделение или назначить на должность.',
  },
  'staff.navSettings': {
    title: 'Настройки в боковом меню',
    text: 'Те же настройки открываются с любой страницы: наведите на пункт «Персонал» в боковом меню — появится шестерёнка.',
  },
  'staff.search': {
    title: 'Поиск',
    text: 'Введите ФИО или другие данные сотрудника и нажмите Enter.',
  },
  'staff.filters': {
    title: 'Фильтры колонок',
    text: 'Значок воронки в заголовке отбирает сотрудников по должности, подразделению, роли, статусу и дате последнего входа.',
  },
  'staff.filtersBasic': {
    title: 'Фильтры колонок',
    text: 'Значок воронки в заголовке отбирает сотрудников по должности и подразделению.',
  },
  'staff.hideInactive': {
    title: 'Скрыть неактивных',
    text: 'Оставляет в списке только сотрудников с активной учётной записью. «Сбросить фильтры» переключатель не выключает.',
  },
  'staff.resetFilters': {
    title: 'Сбросить фильтры',
    text: 'Возвращает полный список сотрудников.',
  },
  'staff.bulk.roles': {
    title: 'Настройка ролей',
    text: 'Отметьте сотрудников галочками в таблице и назначьте им роли разом.',
  },
  'staff.bulk.access': {
    title: 'Блокировка и восстановление',
    text: 'Закрыть или вернуть доступ к порталу отмеченным сотрудникам.',
  },
  'staff.bulk.export': {
    title: 'Выгрузить',
    text: 'Скачать таблицу: отмеченных сотрудников, а без отметок — всех по текущим фильтрам.',
  },
  'staff.bulk.reports': {
    title: 'Формы и отчёты',
    text: 'Печатные формы и отчёты по отмеченным сотрудникам, а без отметок — по всем с текущими фильтрами.',
  },
  'staff.rowMenu.basic': {
    title: 'Меню сотрудника',
    text: 'Профиль сотрудника и сообщение ему в чат.',
  },
  'staff.rowMenu.view': {
    title: 'Меню сотрудника',
    text: 'Профиль, сообщение в чат и активность сотрудника в портале.',
  },
  'staff.rowMenu.edit': {
    title: 'Меню сотрудника',
    text: 'Профиль, сообщение в чат и редактирование данных. У заблокированного сотрудника здесь же — восстановление доступа.',
  },
  'staff.rowMenu.full': {
    title: 'Меню сотрудника',
    text: 'Профиль, сообщение в чат, активность и редактирование данных. У заблокированного сотрудника здесь же — восстановление доступа.',
  },
  'staff.edit.personal': {
    title: 'Карточка сотрудника',
    text: 'Открывается пунктом «Редактировать» в меню строки. ФИО, дата рождения и контакты; личный телефон обязателен. Какие поля можно менять, зависит от ваших прав.',
  },
  'staff.edit.structure': {
    title: 'Подразделение и должность',
    text: 'Где работает сотрудник и кем. Оба поля обязательны.',
  },
  'staff.edit.roles': {
    title: 'Роли',
    text: 'Роли открывают сотруднику доступ к разделам портала. Наведите на название роли — появится её описание. Блок виден тем, кто может настраивать роли.',
  },
  'staff.edit.signatures': {
    title: 'Электронные подписи',
    text: 'Переход в реестр электронных подписей сразу с отбором по этому сотруднику.',
  },
  'staff.edit.save': {
    title: 'Сохранить',
    text: 'Кнопка станет активной, когда заполнены все обязательные поля.',
  },
  'staff.demoRow': {
    title: 'Активность сотрудника',
    text: 'Клик по строке открывает страницу активности сотрудника.',
  },
  'staff.activity.profile': {
    title: 'Сотрудник и период',
    text: 'Должность, подразделение и рабочий телефон. Справа выберите период, за который показывать активность, и сформируйте отчёт.',
  },
  'staff.activity.edit': {
    title: 'Редактировать',
    text: 'Открывает карточку сотрудника для правки. Доступные поля зависят от ваших прав.',
  },
  'staff.activity.analytics': {
    title: 'Сводная аналитика',
    text: 'Чем сотрудник занимался в портале за выбранный период: НС, заявки и последний вход.',
  },
  'staff.activity.actions': {
    title: 'Последние действия',
    text: 'Журнал действий сотрудника по разделам портала с датой. Его можно отфильтровать.',
  },
}
